<div class="container-box">
  <div class="cash-movements-page">
    <!-- Header -->
    <div class="page-header">
      <div class="header-left">
        <h2 class="page-title">
          <i class="fas fa-coins title-icon"></i>
          Movimenti Cassa
        </h2>
        <span class="results-badge" *ngIf="totalMovements > 0">{{ totalMovements }} movimenti</span>
      </div>
      <div class="header-actions">
        <button class="btn-icon" (click)="reloadTrigger$.next()" title="Aggiorna">
          <i class="fas fa-sync-alt"></i>
        </button>
        <app-button-new-cash-movements action-button></app-button-new-cash-movements>
      </div>
    </div>

    <!-- Table Card -->
    <div class="table-card">
      <app-new-table
        [dataSource]="dataSource"
        [reloadTrigger$]="reloadTrigger$"
        [displayedColumns]="displayedColumns"
        [initialSort]="{
          active: 'dataMovimento',
          direction: 'desc'
        }"
        [hideButtonDelete]="hideButtonDelete"
        (btnDeleteClickEvent)="btnDeleteFunction($event)"
        (btnDetailsClickEvent)="btnDetailsClickFunction($event)"
      ></app-new-table>
    </div>
  </div>
</div>
